import React, {useEffect, useState} from "react";
import {createPortal} from "react-dom";
import "./styles.css";

const ANIMATION_DURATION = 300;

const Drawer = ({
                    open,
                    onClose,
                    width = 320,
                    side = "left",
                    background = "rgba(0, 0, 0, 0.5)",
                    children,
                    paperStyle = {},
                    className = '',
                    overlayClassName = ''
                }) => {
    const [rendered, setRendered] = useState(open);
    const [animatedOpen, setAnimatedOpen] = useState(false);

    useEffect(() => {
        if (!open) {
            setAnimatedOpen(false);
            const timeout = window.setTimeout(() => setRendered(false), ANIMATION_DURATION);
            return () => window.clearTimeout(timeout);
        }

        setRendered(true);

        /* A drawer can be mounted for the first time already open (conversation
           history does this). Give the browser one frame with its translated
           closed position before applying the open class. */
        const frame = window.requestAnimationFrame(() => setAnimatedOpen(true));
        return () => window.cancelAnimationFrame(frame);
    }, [open]);

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") onClose();
        };
        if (open) document.addEventListener("keydown", handleEsc);
        return () => document.removeEventListener("keydown", handleEsc);
    }, [open, onClose]);

    if (!rendered) return null;

    const drawer = (
        <React.Fragment>
            <div
                className={`drawer-overlay ${overlayClassName} ${animatedOpen ? "open" : ""}`}
                style={{ background }}
                onClick={onClose}
            />

            <div
                className={`drawer drawer-${side} ${className} ${animatedOpen ? "open" : ""}`}
                style={{width, ...paperStyle}}
            >
                {children}
            </div>
        </React.Fragment>
    );

    return createPortal(drawer, document.body);
};


export default Drawer;



// WEBPACK FOOTER //
// ./src/components-new/ui/Drawer/index.jsx